import { Reveal, Overline } from "@/components/Reveal";
import { Building2, AlertTriangle, Target, CalendarClock } from "lucide-react";

const CONCERNED = [
  "Bureaux, sièges sociaux et espaces de coworking",
  "Commerces et centres commerciaux",
  "Établissements d'enseignement et universités",
  "Établissements de santé et médico-sociaux",
  "Entrepôts, plateformes logistiques et hôtellerie",
];

const OBLIGATIONS = [
  { icon: Target, t: "Objectifs de réduction", d: "-40% en 2030, -50% en 2040 et -60% en 2050 par rapport à une année de référence, ou atteinte de valeurs absolues par activité." },
  { icon: Building2, t: "Bâtiments concernés", d: "Tout bâtiment ou partie de bâtiment tertiaire d'une surface ≥ 1 000 m², public ou privé." },
  { icon: CalendarClock, t: "Déclaration annuelle", d: "Transmission des consommations sur la plateforme OPERAT de l'ADEME, chaque année." },
  { icon: AlertTriangle, t: "Risques de non-conformité", d: "Mise en demeure, publication du nom (« name & shame ») et amendes administratives." },
];

const TIMELINE = [
  { year: "2022", label: "Première déclaration des consommations sur OPERAT." },
  { year: "2030", label: "Objectif -40% de consommation d'énergie finale." },
  { year: "2040", label: "Objectif -50% de consommation d'énergie finale." },
  { year: "2050", label: "Objectif -60% de consommation d'énergie finale." },
];

export default function DecretTertiaire() {
  return (
    <section id="decret" className="bg-slate-100 py-24 lg:py-32" data-testid="decret-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Overline>Obligation réglementaire</Overline>
          <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-midnight max-w-2xl">
            Le Décret Tertiaire
          </h2>
          <p className="mt-5 text-slate-600 font-light leading-relaxed max-w-2xl">
            Le dispositif Éco Énergie Tertiaire impose une trajectoire de réduction des consommations
            d'énergie aux bâtiments tertiaires. Anticiper est la meilleure stratégie.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
            {OBLIGATIONS.map((o, i) => (
              <Reveal key={o.t} delay={i * 0.07} className="bg-white p-7">
                <o.icon className="h-6 w-6 text-emerald mb-4" strokeWidth={1.5} />
                <h3 className="font-display font-bold text-midnight">{o.t}</h3>
                <p className="mt-2 text-sm text-slate-600 font-light leading-relaxed">{o.d}</p>
              </Reveal>
            ))}
          </div>

          <div>
            <Reveal>
              <div className="bg-white border border-slate-200 p-7">
                <h3 className="font-display font-bold text-midnight mb-2">Bâtiments concernés</h3>
                <ul className="mt-4 space-y-3">
                  {CONCERNED.map((c) => (
                    <li key={c} className="flex gap-3 text-sm text-slate-600">
                      <span className="h-1.5 w-1.5 bg-emerald rounded-full mt-2 shrink-0" />{c}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            {/* Timeline */}
            <Reveal delay={0.1}>
              <div className="mt-8 relative pl-8">
                <div className="absolute left-[7px] top-2 bottom-2 w-px bg-emerald/40" />
                {TIMELINE.map((t) => (
                  <div key={t.year} className="relative mb-7 last:mb-0">
                    <span className="absolute -left-8 top-1 h-4 w-4 rounded-full bg-emerald border-4 border-slate-100" />
                    <div className="font-display text-2xl font-black text-midnight">{t.year}</div>
                    <p className="text-sm text-slate-600 font-light">{t.label}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 bg-midnight text-white p-8 lg:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="font-display text-xl lg:text-2xl font-bold">
              Nous vous accompagnons dans votre stratégie de conformité.
            </p>
            <span className="text-lime overline shrink-0">De l'audit au suivi OPERAT</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
